import React, { useState } from 'react';
import './ZoomEnquiryPop.css';
// import { useRouter } from "next/navigation";

// interface ZoomPopEnquery {
//     isOpen: boolean;
//     onClose: () => void;
//     userData: (data: { name: string, emailaddress: string, phone: string }) => void;
// }

const ZoomPopEnquery = ({ isOpen, onClose, userData }) => {
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [formData, setformData] = useState({
        name: "",
        emailaddress: "",
        phone: "",
    });

    // type formData = {
    //     name: string;
    //     emailaddress: string;
    //     phone: string;
    // };

    const handleChange = (e) => {
        const { name, value } = e.target;
        const newData = { ...formData, [name]: value };
        setformData(newData);
    };

    // const isValidEmail = (email) => {
    //     const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    //     return emailPattern.test(email);
    // };

    // backend url
    // const backendUrl = "https://backend.globedwise.com/zoom";

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage("");

        // Handle form submission logic here
        // if (formData.phone.length !== 10) {
        //     return setMessage("Please enter a valid phone number");
        // }
        if (
            formData.name === ""
            // !isValidEmail(formData.emailaddress) ||
            // formData.phone.length !== 10
        ) {
            setMessage("Please fill all the fields");
            return;
        }

        try {
            setLoading(true);
            setTimeout(() => {
                setMessage("Network Error, please check your internet connection");
            }, 6000);
            // const res = await axios.post(backendUrl, {
            //     data: [
            //         {
            //             Name: formData.name,
            //             Email: formData.emailaddress,
            //             Mobile: `91 ${formData.phone}`,
            //         }
            //     ]
            // });
            userData(formData);
            setLoading(false);
            onClose();
        } catch (error) {
            setLoading(false);
            setMessage("Something went wrong, please try again");
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="popup-overlay-services-content ">
            <div className="popup-content-services-content">
                <button className="close-button" onClick={onClose}>
                    &times;
                </button>
                <h2>Join Our Meeting</h2>

                {message && <p style={{ textAlign: "center", color: "tomato" }}>{message}</p>}

                {/* Form (optional, based on your requirement) */}
                <form onSubmit={handleSubmit}>
                    <div>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                            placeholder="Your Name"
                        />
                    </div>

                    {/* <div>
                        <input
                            type="email"
                            name="emailaddress"
                            value={formData.emailaddress}
                            onChange={handleChange}
                            required
                            placeholder="Your Email"
                        />
                    </div>
                    <div>
                        <input
                            type="number"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            required
                            placeholder="Mobile"
                        />
                    </div> */}
                    <button disabled={loading} type="submit">
                        {loading ? "Wait..." : "Submit"}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ZoomPopEnquery;